export default {"src":"/_next/static/media/active-experience-icon.4615051c.svg","height":34,"width":27};